import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';

export interface RateRegenRequest {
    scope: string;           // 'ALL' | 'RANGE' | 'LIST'
    strIdStart?: number;
    strIdEnd?: number;
    strIds?: number[];
    generateRates?: boolean;
    generateLos?: boolean;
    triggerName?: string;
}

export interface RateRegenJobLog {
    scheduleJobLogId: number;
    jobName: string;
    serverName: string;
    triggerName: string;
    jobStatus: number;       // 1=STARTED, 2=RECOVERED, 3=FINISHED, 4=FAILED
    totalItems: number;
    processedItems: number;
    startTime: string;
    endTime: string;
    lastUpdate: string;
    metadata: string;
}

export interface RateRegenStatusResponse {
    parent: RateRegenJobLog;
    children: RateRegenJobLog[];
}

@Injectable({ providedIn: 'root' })
export class RateRegenService {

    readonly SCOPE_ALL   = 'ALL';
    readonly SCOPE_RANGE = 'RANGE';
    readonly SCOPE_LIST  = 'LIST';

    readonly STATUS_STARTED  = 1;
    readonly STATUS_RECOVERED = 2;
    readonly STATUS_FINISHED = 3;
    readonly STATUS_FAILED   = 4;

    constructor(private http: HttpClient) {}

    startRegenAtl(request: RateRegenRequest): Observable<any> {
        return this.http.post(`${environment.atlRptApiUrl}/rates/regenerate`, request);
    }

    startRegenNyc(request: RateRegenRequest): Observable<any> {
        return this.http.post(`${environment.nycRptApiUrl}/rates/regenerate`, request);
    }

    getStatusAtl(scheduleJobLogId: number): Observable<any> {
        return this.http.get(`${environment.atlRptApiUrl}/rates/regenerate/status/${scheduleJobLogId}`);
    }

    getStatusNyc(scheduleJobLogId: number): Observable<any> {
        return this.http.get(`${environment.nycRptApiUrl}/rates/regenerate/status/${scheduleJobLogId}`);
    }

    getRecentJobsAtl(limit = 20): Observable<any> {
        return this.http.get(`${environment.atlRptApiUrl}/rates/regenerate/recent?limit=${limit}`);
    }

    getRecentJobsNyc(limit = 20): Observable<any> {
        return this.http.get(`${environment.nycRptApiUrl}/rates/regenerate/recent?limit=${limit}`);
    }

    isTerminal(status: number): boolean {
        return status === this.STATUS_FINISHED || status === this.STATUS_FAILED;
    }

    statusLabel(status: number): string {
        switch (status) {
            case this.STATUS_STARTED:   return 'Running';
            case this.STATUS_RECOVERED: return 'Recovered';
            case this.STATUS_FINISHED:  return 'Finished';
            case this.STATUS_FAILED:    return 'Failed';
            default:                    return 'Unknown';
        }
    }

    statusSeverity(status: number): string {
        switch (status) {
            case this.STATUS_FINISHED: return 'success';
            case this.STATUS_FAILED:   return 'danger';
            case this.STATUS_STARTED:
            case this.STATUS_RECOVERED: return 'info';
            default:                    return 'secondary';
        }
    }
}
